const steps = [
  { num: "01", title: "Choose Your Service", desc: "Emergency, expedited, or standard — based on your departure timeline." },
  { num: "02", title: "Complete Application", desc: "We guide you through DS-11 or DS-82 with no errors." },
  { num: "03", title: "Visit Acceptance Facility", desc: "We direct you to the Fort Smith facility with the shortest wait." },
  { num: "04", title: "We Handle Processing", desc: "Your application is couriered to the State Department for priority processing." },
  { num: "05", title: "Receive Your Passport", desc: "Delivered via secure courier with real-time tracking." },
];

export default function FortSmithHowItWorksSection() {
  return (
    <section id="how-it-works" className="py-16 md:py-24 bg-[#F7F8FA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">How It Works</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">5 Steps to Your Passport</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
          {steps.map((s, i) => (
            <div key={i} className="text-center">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#1A365D] text-white font-bold text-lg mx-auto mb-4">{s.num}</div>
              <h3 className="font-bold text-[#1A365D] text-base mb-2">{s.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}